(function(globals){
  'use strict';

  globals.addEventListener('load', function() {
    // Find all elements on page with "data-tracking" attribute
    var links = document.querySelectorAll('[data-tracking]');

    // Cycle through links and add click-handler to each link for tracking
    for (var i = 0; i < links.length; i++) {
      links[i].addEventListener('click', function () {
        var data = JSON.parse(this.getAttribute('data-tracking')),
          category = data.category ? data.category : null,
          action = data.action ? data.action : null,
          label = data.label ? data.label : null,
          context = data.context ? data.context : null;

        globals.spAnalytics.logEvent(category, action, label, context);

        globals.dataLayer = globals.dataLayer || [];
        globals.dataLayer.push({
          'event': 'GAEventMorpheus',
          'eventCategory': category,
          'eventAction': action,
          'eventLabel': label
        });
      });
    }
  });
})(typeof global !== 'undefined' ? global : window);
